import { createContext } from 'react';

const ChannelContext = createContext({
    hideChannelManagementDelegationNotice: () => {},
});

export default ChannelContext;
